export default __webpack_public_path__ + "static/media/LFEX-name-light.9c6d1973.png";